import { QUESTION_NAMES, QUESTION_TYPES } from './constants';

export function validateInsuranceCards(value, model) {
  const frontCard = model.prescreener?.insuranceCardFront;
  const backCard = model.prescreener?.insuranceCardBack;

  return model.required && frontCard && backCard;
}

export function validateFileUpload(value, model) {
  if (model.type === QUESTION_TYPES.FILE && model.name === QUESTION_NAMES.INSURANCE_CARD_UPLOAD) {
    return validateInsuranceCards(value, model);
  }
  return true;
}
